import "./components/swiper";
import "./components/burg";
import "./components/smooth";
import "./components/modal";
import "./components/top";
